import * as R from 'ramda';

import { fnHighlightSearchResult } from 'components/Search/elements/QuickSearch/QuickSearchResultsList/helpers';

const fnNormalizeQuickSearchHits = (aHits) =>
  aHits.map((oHit) => ({
    LOOKUPID: oHit.id,
    NAME: oHit.fields.name[0],
    NICKNAME: oHit.fields.nickname?.[0],
    LAST_NAME: oHit.fields.last_name?.[0],
    HIGHLIGHT: fnHighlightSearchResult(oHit),
  }));

const fnNormalizeMyNetworkSearchResults = (aResults = []) =>
  aResults.map((oResult) => ({
    LOOKUPID: oResult.obj.LOOKUPID,
    NAME: oResult.obj.NAME,
    NICKNAME: oResult.obj.NICKNAME,
    LAST_NAME: oResult.obj.LASTNAME,
    HIGHLIGHT: oResult[0].highlight(),
  }));

const fnNormalizeManuallyCreatedGuestsResults = (aResults = []) =>
  aResults.map((oResult) => ({
    LOOKUPID: oResult.obj.LOOKUPID,
    NAME: oResult.obj.NAME,
    NICKNAME: oResult.obj.FIRST_NAME,
    FIRST_NAME: oResult.obj.FIRST_NAME,
    LAST_NAME: oResult.obj.LAST_NAME,
    EMAIL_ADDRESS: oResult.obj.EMAIL_ADDRESS,
    HIGHLIGHT: oResult[0].highlight(),
  }));

/**
 * Combines quick search results, My Network search results, and manually created guests into a single array.
 * Ordered like this: [manually created guests, My Network results, quick search results]
 *
 * @param {array} aQuickSearchHits - Quick search results
 * @param {array} aMyNetworkSearchResults - My Network search results
 * @param {array} aManuallyCreatedGuestsResults - Manually created guests search results
 * @returns {array}
 */
const fnCombineSearchResults = (
  aQuickSearchHits,
  aMyNetworkSearchResults,
  aManuallyCreatedGuestsResults = []
) => {
  const aNormalizedQuickSearchResults =
    fnNormalizeQuickSearchHits(aQuickSearchHits);
  const aNormalizedMyNetworkSearchResults = fnNormalizeMyNetworkSearchResults(
    aMyNetworkSearchResults
  );
  const aNormalizedManuallyCreatedGuestsResults =
    fnNormalizeManuallyCreatedGuestsResults(aManuallyCreatedGuestsResults);

  const aCombinedResults = [
    ...aNormalizedManuallyCreatedGuestsResults,
    ...aNormalizedMyNetworkSearchResults,

    ...aNormalizedQuickSearchResults,
  ];
  return R.uniqBy(R.prop('LOOKUPID'), aCombinedResults);
};

export default fnCombineSearchResults;
